import { Component } from 'yuzu'
import Events from '@/js/core/EventDispatcher'
import $ from 'jquery'

export default class BaseComponent extends Component {
  $ = {}
  
  state = {
    intersection: undefined,
  }
  
  mounted () {
    this.$.el = $(this.$el)
    this.$.win = $(window)
    this.$.body = $(document.body)
    for (const key in this.$els) {
      const node = this.$els[key]
      this.$[key] = $(node)
    }

    Events.on('intersect:update', ({ target, isIntersecting }) => {
      if (isIntersecting === undefined) return
      if (target === this.$el) {
        this.setState(() => ({
          intersection: isIntersecting,
        }))
      }
    })
  }
}